import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../services/AuthContext";
import { RadioContext } from "../../services/RadioProvider";
import "./Logo.css";

export default function Logo() {
    const { isLoggedIn, setUserModalOpen } = useContext(AuthContext);
    const { nowPlaying } = useContext(RadioContext);
    const { listeners } = nowPlaying

    useEffect(() => {
    }, [nowPlaying]);

    const className = isLoggedIn ? "d-is-logged-in" : "d-is-not-logged-in";
    return (
        <div className="d-logo-main">
            <div className="d-logo-img-link">
                <div className="d-logo-text">
                    <a  href="https://cueroom.online">
                        <img className="d-vip-logo" src="/images/logo.png" alt="VIP Radio Logo" />
                    </a>
                </div>
                {/* <div className="d-logo-text">
                    <a href="https://vip-radio.online">
                        <div className="d-vip">VIP-RADIO.ONLINE</div>
                        <div className="d-cool">Cool Online Music</div>
                    </a>
                </div> */}
                <button className={`d-user ${className}`} onClick={() => setUserModalOpen(true)}><i className="fas fa-user"></i></button>
            </div>
            <div className="d-logo-listeners">
                <h1>
                    <div className="d-m-title-listeners">
                        <div>
                            <i className="fas fa-headphones"></i>
                            <span className="d-m-listener-count">{listeners}</span>
                        </div>
                    </div>
                </h1>
            </div>
        </div>
    );
}